import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Trans } from 'react-i18next';
import { robotSlice } from '../../../redux/RobotSlice';
import { RobotActions } from '../../../utils/constants';

const UpdateConfirmationDialog = ({ onClose }) => {
  const dispatch = useDispatch();

  const handleCloseAndContinue = () => {
    onClose();
    dispatch(robotSlice.actions.onFirmwareStateChange({ firmwareState: RobotActions.FIRMWARE_UPDATE.START_DOWNLOAD }));
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <DialogTitle variant="sectionTitle" align="center">
        <Trans i18nKey="updateConfirmationDialog.title">Update Confirmation</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="body1">
            <Trans i18nKey="updateConfirmationDialog.text1">Are you REALLY sure you want to update your firmware?</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans i18nKey="updateConfirmationDialog.text2">
              If you proceed, you will be unable to cancel the update while it&apos;s in progress. Leave your robot and device powered on and close to
              each other until the update has finished
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ justifyContent: 'center', margin: '2px 0' }}>
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button variant="text" autoFocus onClick={handleClose}>
            <Trans i18nKey="button.cancel">Cancel</Trans>
          </Button>
          <Button color="error" variant="contained" autoFocus onClick={handleCloseAndContinue}>
            <Trans i18nKey="updateConfirmationDialog.updateFirmware">Update Firmware</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};

UpdateConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default UpdateConfirmationDialog;
